export const getPanelKey = (panel) => panel?.unique_id || panel?.id;

const stableValue = (value) => {
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(stableValue);
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = stableValue(value[key]);
        return acc;
      }, {});
  }
  return value;
};

export const buildPanelRequestKey = ({
  dashboardId,
  panel,
  filterConfig = [],
  filterValues = {},
  extra = undefined,
} = {}) => {
  const chartType = panel?.chart_type || panel?.type;
  const dependent =
    (Array.isArray(panel?.y_columns) &&
      panel.y_columns.length > 0 &&
      panel.y_columns[0]?.column_name) ||
    "";

  return JSON.stringify(
    stableValue({
      dashboardId,
      panelKey: getPanelKey(panel),
      chartType,
      dataTableId: panel?.data_table_id || null,
      aggregateBy: panel?.aggregate_by || "",
      aggregationOp: panel?.aggregation_op || "",
      dependent,
      xColumnName: panel?.x_column_name || "",
      filterConfig,
      filterValues,
      extra,
    })
  );
};

export const tracePanelRequest = ({
  phase,
  panel,
  filterValues = {},
  extra = undefined,
} = {}) => {
  if (process.env.NODE_ENV === "production") return;

  const chartType = panel?.chart_type || panel?.type;
  // eslint-disable-next-line no-console
  console.debug("[dashboard-panel-request]", {
    phase,
    panelId: getPanelKey(panel),
    chartType,
    data_table_id: panel?.data_table_id,
    aggregateBy: panel?.aggregate_by,
    metricOp: panel?.aggregation_op,
    filterValues,
    extra,
  });
};
